import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cca6a022"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrap"
};
const _hoisted_2 = {
  class: "news-tab"
};
const _hoisted_3 = {
  class: "news-column"
};
const _hoisted_4 = {
  key: 0,
  class: "first-news news"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "van-multi-ellipsis--l2"
};
const _hoisted_7 = {
  class: "time flex align-items"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-reading"
}, null, -1));
const _hoisted_9 = {
  class: "other-news"
};
const _hoisted_10 = {
  class: "news-list news"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "left-title"
};
const _hoisted_13 = {
  class: "van-multi-ellipsis--l2"
};
const _hoisted_14 = {
  class: "time flex align-items"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-reading"
}, null, -1));
const _hoisted_16 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_header = _resolveComponent("top-header");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_news_tab = _resolveComponent("news-tab");
  const _component_van_list = _resolveComponent("van-list");
  const _component_bottom_foot = _resolveComponent("bottom-foot");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(() => [_createVNode(_component_top_header, {
      scenario: $data.scenario
    }, null, 8, ["scenario"])]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_news_tab, {
    config: $data.config,
    flag: $data.flag,
    onSearch: $options.search
  }, null, 8, ["config", "flag", "onSearch"])]), _createElementVNode("div", _hoisted_3, [$data.data[0] ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[0] || (_cache[0] = $event => $options.actionTo('/news/' + $data.data[0].newsid))
  }, [_createElementVNode("img", {
    src: $data.data[0].imageUrl
  }, null, 8, _hoisted_5), _createElementVNode("h3", _hoisted_6, _toDisplayString($data.data[0].description ? $data.data[0].description : $data.data[0].title), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, _toDisplayString($data.data[0].addtime_str), 1), _createElementVNode("p", null, [_hoisted_8, _createTextVNode(" " + _toDisplayString($data.data[0].viewnum), 1)])])])])) : _createCommentVNode("", true), _createVNode(_component_van_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[1] || (_cache[1] = $event => $data.loading = $event),
    finished: $data.finished,
    "finished-text": $data.data.length > 0 ? '我是有底线的' : '',
    onLoad: $options.load,
    offset: "0"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.data, (item, key) => {
      return _openBlock(), _createElementBlock("div", _hoisted_10, [key != 0 ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: "javascript:;",
        onClick: $event => $options.actionTo('/news/' + item.newsid),
        class: "flex"
      }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("h3", _hoisted_13, _toDisplayString(item.description ? item.description : item.title), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", null, _toDisplayString(item.addtime_str), 1), _createElementVNode("p", null, [_hoisted_15, _createTextVNode(_toDisplayString(item.viewnum), 1)])])]), _createElementVNode("img", {
        src: item.imageUrl
      }, null, 8, _hoisted_16)], 8, _hoisted_11)) : _createCommentVNode("", true)]);
    }), 256))])]),
    _: 1
  }, 8, ["loading", "finished", "finished-text", "onLoad"])]), _createVNode(_component_bottom_foot)]);
}